import { STRIPE_MONTHLY_PRICE_ID, STRIPE_YEARLY_PRICE_ID } from "./env";

export const ICON_SIZE = {
  sm: 16,
  md: 18,
  lg: 20,
};

export const TRANSITION_EASINGS = {
  ease: [0.36, 0.66, 0.4, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1],
  spring: [0.155, 1.105, 0.295, 1.12],
  springOut: [0.57, -0.15, 0.62, 0.07],
  softSpring: [0.16, 1.11, 0.3, 1.02],
} as const;

export const MODAL_ANIMATION = {
  variants: {
    enter: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.2, ease: "ease-out" },
    },
    exit: {
      y: "100%",
      opacity: 0,
      transition: { duration: 0.15, ease: "ease-in" },
    },
  },
};

export const SCALE_IN_AND_OUT = {
  enter: {
    scale: "var(--scale-enter)",
    y: "var(--slide-enter)",
    opacity: 1,
    willChange: "auto",
    transition: {
      scale: {
        duration: 0.4,
        ease: TRANSITION_EASINGS.ease,
      },
      opacity: {
        duration: 0.4,
        ease: TRANSITION_EASINGS.ease,
      },
      y: {
        type: "spring",
        bounce: 0,
        duration: 0.6,
      },
    },
  },
  exit: {
    scale: "var(--scale-exit)",
    y: "var(--slide-exit)",
    opacity: 0,
    willChange: "transform",
    transition: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease,
    },
  },
};

export const ROOT_ROUTES = ["/notes/:folderId", "/todos", "/settings", "/home"];

export const ROUTES_TO = {
  home: "/home",
  notes: "/notes/0",
  todos: "/todos",
  settings: "/settings",
  onboarding: "/onboarding",
};

export const TOAST_TIMEOUT = 5000;
export const TOOLTIP_DELAY = 400;
export const TRIAL_DAYS = 7;

export const STRIPE_PRICES_IDS = {
  monthly: {
    id: STRIPE_MONTHLY_PRICE_ID,
    price: 5.99,
  },
  yearly: {
    id: STRIPE_YEARLY_PRICE_ID,
    price: 59.9,
  },
};

export const EXTERNAL_LINKS = {
  contact: "https://www.inkrows.com/contact",
  about: "https://inkrows.com",
  privacy: "https://inkrows.com/legal/privacy-policy",
  terms: "https://inkrows.com/legal/terms-and-conditions",
} as const;

const BOTTOM_NAV_BASE_HEIGHT = 60;
const BOTTOM_FAB_BASE_OFFSET = 16;

const BOTTOM_NAV_HEIGHT = 64;
const BOTTOM_NAV_BOTTOM = 12;

const FAB_BOTTOM = 12;
export const LAYOUT = {
  mobile: {
    bottomNav: {
      height: BOTTOM_NAV_HEIGHT,
      bottom: `calc(${BOTTOM_NAV_BOTTOM}px + var(--inset-bottom))`,
    },
    fab: {
      bottomWithNav: `calc(${BOTTOM_NAV_HEIGHT + BOTTOM_NAV_BOTTOM + FAB_BOTTOM}px + var(--inset-bottom))`,
      bottomWithoutNav: `calc(${FAB_BOTTOM}px + var(--inset-bottom))`,
    },
    bottomPadding: `calc(${BOTTOM_NAV_HEIGHT + BOTTOM_NAV_BOTTOM}px + var(--inset-bottom))`,
    navHeight: 64,
    bottomNavHeight: `calc(${BOTTOM_NAV_BASE_HEIGHT}px + var(--inset-bottom))`,
    bottomFabWithNavOffset: `calc(${BOTTOM_FAB_BASE_OFFSET}px + ${BOTTOM_NAV_BASE_HEIGHT}px + var(--inset-bottom))`,
    bottomFabOffset: `calc(${BOTTOM_FAB_BASE_OFFSET}px + var(--inset-bottom))`,
  },
};

export const LANGUAGE_OPTIONS = [
  { label: "Arabic", value: "ar-SA" },
  { label: "Chinese (Hong Kong)", value: "zh-HK" },
  { label: "Chinese (Simplified)", value: "zh-CN" },
  { label: "Chinese (Traditional)", value: "zh-TW" },
  { label: "Czech", value: "cs-CZ" },
  { label: "Danish", value: "da-DK" },
  { label: "Dutch", value: "nl-NL" },
  { label: "English (Australia)", value: "en-AU" },
  { label: "English (Canada)", value: "en-CA" },
  { label: "English (India)", value: "en-IN" },
  { label: "English (UK)", value: "en-GB" },
  { label: "English (US)", value: "en-US" },
  { label: "Finnish", value: "fi-FI" },
  { label: "French (Canada)", value: "fr-CA" },
  { label: "French (France)", value: "fr-FR" },
  { label: "German", value: "de-DE" },
  { label: "Greek", value: "el-GR" },
  { label: "Hebrew", value: "he-IL" },
  { label: "Hindi", value: "hi-IN" },
  { label: "Indonesian", value: "id-ID" },
  { label: "Italian", value: "it-IT" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Korean", value: "ko-KR" },
  { label: "Norwegian", value: "no-NO" },
  { label: "Polish", value: "pl-PL" },
  { label: "Portuguese (Brazil)", value: "pt-BR" },
  { label: "Portuguese (Portugal)", value: "pt-PT" },
  { label: "Romanian", value: "ro-RO" },
  { label: "Russian", value: "ru-RU" },
  { label: "Spanish (Argentina)", value: "es-AR" },
  { label: "Spanish (Mexico)", value: "es-MX" },
  { label: "Spanish (Spain)", value: "es-ES" },
  { label: "Swedish", value: "sv-SE" },
  { label: "Thai", value: "th-TH" },
  { label: "Turkish", value: "tr-TR" },
  { label: "Ukrainian", value: "uk-UA" },
  { label: "Vietnamese", value: "vi-VN" },
];
